<template>
    <div id="pro-layout"
         class="open-form sit-form-container">
        <sit-form-container :code="code"
                            :loaded="loaded"
                            :logo="logo"
                            :organism="organism"
                            :referent="referent"
                            :sit="true"
                            :draft="draft">
        </sit-form-container>
    </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from "vuex"
import hash from "object-hash"
import SitFormContainer from "./SitFormContainer.vue"
import { answerDiffsFieldsLabel } from "../../../../static/answerDiffsFieldsLabel"
import PhoneNumber from "awesome-phonenumber"

export default {
    name: "SitForm",
    components: { SitFormContainer },
    data() {
        return {
            loaded: false,
            code: null,
            providerId: null,
            communes: [],
            contacts: [],
            referent: {},
            logo: {},
            organism: null,
            txtIntro: {},
            copyrightDialog: false,
            baseOpeningPeriods: null,
            basePricePeriods: null,
            draftInterval: null,
            webFormState: null,
            baseProviderHash: null,
            token: null,
            hasError: false,
            comToParses: [],
            dayToParses: [],
            suggestedLocalisation: null,
            draft: null,
        }
    },

    methods: {
        ...mapMutations("web_form", [
            "resetState",
            "setProvider",
            "setFields",
            "setFamilyElements",
            "setContact",
            "setCategoryFamilies",
            "setIsDirty",
            "setAiEnabled",
            "setId",
            "generateTabulations",
            "handleSpecificTabulation",
            "orderTabulations",
            "generateTabActiveRanges",
            "setOrigin",
            "setIsOpenForm",
            "setInitProvider",
            "setBasePricePeriods",
            "setBaseOpeningPeriods",
            "setCurrency",
            "formatPricePeriods",
            "formatContents",
            "formatCommunications",
            "formatPricePeriods",
            "setSourcesLoaded",
            "setReadOnly",
            "resetTabDiff",
            "setGeneralTabDirty",
            "setLocalisationTabDirty",
            "setCommunicationTabDirty",
            "setPlatformTabDirty",
            "setMediaTabDirty",
            "setOpeningTabDirty",
            "setPricesTabDirty",
            "setContactTabDirty",
            "setSpecificTabDirty",
            "setCardName",
            "setSuggestedH24",
            "setAllSuggestedMediasLoaded",
            "setAllSuggestedMediasLoaded",
            "pushSuggestedMedias",
            "setAccountTisType",
            "pushSuggestedCommunications",
            "setSuggestedAddress",
            "setSuggestedCommune",
            "setSuggestedOpeningDays",
            "setDeeplTranslatorEnabled",
        ]),
        ...mapMutations("sitAnswer", [
            "setDiffs",
        ]),
        setBasePeriods(initProvider, thenDraft = false) {
            setTimeout(() => {
                this.$global.loading = true
                this.setInitProvider(initProvider)
                this.setBasePricePeriods()
                this.setBaseOpeningPeriods()

                if (!thenDraft) {
                    this.$global.loading = false
                }
            }, 2000)
        },
        getProvider(providerDataId = null, thenDraft = false, originAnswerId = null) {
            let payload = {
                provider_id: this.providerId,
                provider_data_id: providerDataId,
            }
            this.$global.loading = true
            return this.$http.post("sitform/get-sit-provider-data", payload).then((res) => {
                this.formatProvider(res, thenDraft, originAnswerId)
            })
        },
        formatProvider(res, thenDraft = false, originAnswerId = null) {
            this.$global.loading = true
            this.setIsDirty(false)
            this.baseProviderHash = null

            if (res.body.code !== null && res.body.code !== undefined) {
                this.hasError = true
                this.code = res.body.code
            }

            if (res.body.success) {
                let families = res.body.data.categoryFamilies
                this.organism = res.body.data.organism
                let provider = res.body.data.provider
                let initProvider = res.body.data.initProvider
                let answer = res.body.data.answer

                if (initProvider === null) {
                    initProvider = provider
                }

                if (answer !== null && answer !== undefined && answer.web_form !== null) {
                    this.token = answer.web_form.token

                    if (["DRAFT", "SAVING_DRAFT"].includes(answer.web_form.state.code)) {
                        this.draft = {
                            user_name: answer.web_form.user.last_name,
                            user_first_name: answer.web_form.user.first_name,
                            user_id: answer.web_form.user.id,
                            drafted_at: answer.drafted_at,
                            provider_data_id: answer.provider_data_versions[0].id,
                            web_form_id: answer.web_form.id,
                            provider_id: this.$route.params.providerId,
                            origin_answer_id: answer.web_form.origin_answer_id,
                        }
                    }
                } else {
                    this.draft = null
                }

                this.setProvider(provider)
                this.setFields(res.body.data.fields)
                this.formatContents(this.languages)
                this.formatCommunications(this.communicationTypes)
                this.setFamilyElements(res.body.data.referential)
                this.setContact(res.body.data.contact)
                this.setCategoryFamilies(families)
                this.setAiEnabled(res.body.data.aiEnabled)
                this.setCurrency(res.body.data.currency)
                this.formatPricePeriods()
                this.setCardName(this.provider.name)
                this.setAccountTisType("DAHUB_QUEBEC")
                this.setDeeplTranslatorEnabled(res.body.data.deeplTranslatorEnabled)

                if (answer !== null) {
                    let contact = {
                        first_name: answer.first_name,
                        last_name: answer.last_name,
                        email: answer.email,
                        id: res.body.data.contact?.id,
                        token: res.body.data.contact?.token,
                    }

                    this.setContact(contact)
                }

                this.setBasePeriods(initProvider, thenDraft)
                this.referent = res.body.data.referent
                this.loaded = true

                this.generateTabulations(true)
                this.handleSpecificTabulation()
                this.orderTabulations()
                this.setDiffs(res.body.data.diffs)

                if (this.diffs !== null) {
                    this.setTabsDirty()
                } else {
                    this.resetTabDiff()
                }

                setTimeout(() => {
                    this.$global.loading = true
                    this.generateTabActiveRanges()

                    if (this.draft && !this.draft.origin_answer_id) {
                        this.setSourcesLoaded(true)
                    }
                }, 1000)

                if (thenDraft) {
                    this.$global.$emit("prepare-edit", originAnswerId)
                }
            } else {
                this.loaded = true
            }
        },
        setTabsDirty() {
            Object.values(this.diffs).forEach(diff => {
                let tab = answerDiffsFieldsLabel.find(field => field.name === diff.dataType).tab

                if (tab === "general-tab") {
                    this.setGeneralTabDirty(true)
                } else if (tab === "localisation-tab") {
                    this.setLocalisationTabDirty(true)
                } else if (tab === "contact-tab") {
                    this.setCommunicationTabDirty(true)
                } else if (tab === "platform-tab") {
                    this.setPlatformTabDirty(true)
                } else if (tab === "media-tab") {
                    this.setMediaTabDirty(true)
                } else if (tab === "specific-tab") {
                    this.setSpecificTabDirty(true)
                } else if (tab === "opening-period-tab") {
                    this.setOpeningTabDirty(true)
                } else if (tab === "price-period-tab") {
                    this.setPricesTabDirty(true)
                } else if (tab === "contacts-tab") {
                    this.setContactTabDirty(true)
                }
            })
        },
        fetchExternalMedias(source) {
            let payload = {
                source: source,
                token: this.token,
                providerId: this.providerId,
                mediaLimit: 3,
            }

            return this.$http.post("online-presence/medias", payload).then(res => {
                let medias = res.body.data.medias
                let communications = res.body.data.communications
                let localisation = res.body.data.localisation
                let openingDays = res.body.data.openingDays ?? []
                let h24 = res.body.data.h24

                if (h24) {
                    this.setSuggestedH24(h24)
                }

                if (medias.length < 3 && source === "GOOGLE") {
                    this.setAllSuggestedMediasLoaded(true)
                }

                medias = medias.map(media => {
                    if (media.thumbnail_url === null) {
                        media.thumbnail_url = media.origin_url
                    }

                    return media
                })

                this.comToParses = [...this.comToParses, ...communications]
                this.dayToParses = [...this.dayToParses, ...openingDays]

                this.pushSuggestedMedias(medias)

                if (localisation !== null) {
                    this.suggestedLocalisation = localisation
                }
            })
        },
        parseSuggestedCommunications() {
            this.comToParses.forEach(com => {
                let hasSuggestion = this.suggestedCommunications.find(suggestedCom => suggestedCom.type.name === com.type.name)

                if (hasSuggestion === undefined && this.provider !== null) {
                    let hasSameValue = false

                    this.provider.communications.forEach(providerCom => {
                        if (providerCom.type.name === com.type.name && !hasSameValue) {
                            if (providerCom.type.name === "PHONE" || providerCom.type.name === "FAX") {
                                let phone1 = com.value !== null ?
                                  new PhoneNumber(com.value, "FR").getNumber() : null
                                let phone2 = providerCom.value !== null ?
                                  new PhoneNumber(providerCom.value, "FR").getNumber() : null

                                hasSameValue = phone1 === phone2
                            } else if (["WEBSITE", "TRIPADVISOR", "YELP", "FACEBOOK", "GOOGLE", "YOUTUBE", "INSTAGRAM", "LINKEDIN", "TIKTOK"]
                              .includes(providerCom.type.name)) {
                                let url1 = com.value ?? ""

                                url1 = url1.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                let url2 = providerCom.value ?? ""

                                url2 = url2.replace(/^(?:https?:\/\/)?(?:www\.)?/i, "")

                                if (url1.charAt(url1.length - 1) === "/") {
                                    url1 = url1.substr(0, url1.length - 1)
                                }

                                if (url2.charAt(url2.length - 1) === "/") {
                                    url2 = url2.substr(0, url2.length - 1)
                                }

                                if (com.type.name === "GOOGLE") {
                                    let index1 = url1.indexOf("&")
                                    if (index1 >= 0) {
                                        url1 = url1.slice(0, index1)
                                    }

                                    let index2 = url2.indexOf("&")
                                    if (index2 >= 0) {
                                        url2 = url2.slice(0, index2)
                                    }
                                } else if (["FACEBOOK", "INSTAGRAM"].includes(com.type.name)) {
                                    let index1 = url1.indexOf("?")
                                    if (index1 >= 0) {
                                        url1 = url1.slice(0, index1 - 1)
                                    }

                                    let index2 = url2.indexOf("?")
                                    if (index2 >= 0) {
                                        url2 = url2.slice(0, index2 - 1)
                                    }
                                }

                                hasSameValue = url1 === url2
                            } else if (providerCom.value === com.value) {
                                hasSameValue = true
                            }
                        }
                    })

                    if (!hasSameValue) {
                        this.pushSuggestedCommunications([com])
                    }
                }
            })
        },
        parseSuggestedLocalisation() {
            if (this.provider !== undefined && this.provider !== null) {
                let lowerAddr = this.provider.localisation.address !== null ? this.provider.localisation.address.toLocaleLowerCase() : null
                if (this.suggestedLocalisation !== null &&
                  this.suggestedLocalisation.address !== null) {

                    let lowerSuggestAddr = this.suggestedLocalisation.address.toLocaleLowerCase()
                    lowerSuggestAddr = lowerSuggestAddr.replace(",", "")
                    lowerAddr = lowerAddr.replace(",", "")

                    if (lowerSuggestAddr !== lowerAddr) {
                        this.setSuggestedAddress(this.suggestedLocalisation.address)
                    }
                }

                if (this.suggestedLocalisation !== null &&
                  this.suggestedLocalisation.commune !== null &&
                  this.suggestedLocalisation.commune.id !== this.provider.localisation.commune.id) {

                    this.setSuggestedCommune(this.suggestedLocalisation.commune)
                }
            }
        },
        parseSuggestedOpeningDays() {
            if (this.provider !== null) {
                if (this.provider.opening_periods.length === 0) {
                    this.setSuggestedOpeningDays(this.dayToParses)
                } else {
                    let period = this.provider.opening_periods[0]
                    let hasDiffs = false

                    this.dayToParses.forEach(dayToParse => {
                        const day = period.opening_days.find(openingDay => openingDay.day_of_week === dayToParse.day_of_week)

                        if (dayToParse.opening_hours.length === 0) {
                            dayToParse.opening_hours.push({ open: null, close: null })
                        }

                        if (day !== null && day !== undefined) {
                            hasDiffs = (day.closed !== dayToParse.closed ||
                              hash(this.cleanEmptyHours(day.opening_hours)) !==
                              hash(this.cleanEmptyHours(dayToParse.opening_hours))) || hasDiffs
                        }
                    })

                    if (hasDiffs) {
                        this.dayToParses.forEach(dayToParse => {
                            this.setSuggestedOpeningDays([dayToParse])
                        })
                    }
                }
            }
        },
    },
    computed: {
        ...mapState("web_form", [
            "provider",
            "contact",
            "categoryFamilies",
            "isDirty",
            "readOnly",
            "suggestedCommunications",
            "origin",
        ]),
        ...mapState("resource", [
            "communicationTypes",
            "languages",
        ]),
        ...mapState("account", ["user"]),
        ...mapState("sitAnswer", ["diffs"]),
        ...mapGetters("web_form", [
            "hasField",
            "hasFamilyElement",
            "getFamilyByCode",
            "getElementsByFamilyCode",
        ]),
    },

    watch: {
        webFormState() {
            if (this.draftInterval !== null && this.webFormState === "DRAFT") {
                clearInterval(this.draftInterval)
            }
        },
        readOnly() {
            if (this.readOnly === false) {
                this.fetchExternalMedias("GOOGLE")
                this.fetchExternalMedias("GOOGLE_CUSTOM")

                setTimeout(() => {
                    this.parseSuggestedCommunications()
                    this.parseSuggestedLocalisation()
                    this.parseSuggestedOpeningDays()
                }, 500)
            }
        },
    },
    async created() {
        this.resetState()

        this.setOrigin("SIT")
        this.setIsOpenForm(true)

        this.providerId = this.$route.params.providerId

        this.setId(this.providerId)
        this.setReadOnly(true)

        this.$store.dispatch("resource/fetchLanguages")
        this.$store.dispatch("resource/fetchProfessions")
        this.$store.dispatch("resource/fetchCurrencies")
        await this.$store.dispatch("resource/fetchCommunicationTypes")

        let promise1 = this.getProvider()

        if (this.$route.query.fromAnswer !== undefined) {
            promise1 = this.getProvider(this.$route.query.providerDataId, true, this.$route.query.fromAnswer)
        } else if (this.$route.query.providerDataId && this.$route.query.newDraft === true) {
            promise1 = this.getProvider(this.$route.query.providerDataId, true)
        } else if (this.$route.query.providerDataId && this.$route.query.newDraft === false) {
            promise1 = this.getProvider(this.$route.query.providerDataId)
        }
        this.$global.loading = true

        Promise.all([promise1]).then(() => {
            if (this.$route.query.providerDataId) {
                this.setReadOnly(false)
                this.$router.push({
                    path: "/sit/formulaire/" + this.providerId,
                })
            }
        })

        this.$global.$on("get-provider", (providerDataId) => {
            this.getProvider(providerDataId)
        })

        this.$global.$on("format-provider", (res) => {
            this.formatProvider(res)
        })

        window.onbeforeunload = () => {
            return true
        }
    },
    beforeDestroy() {
        window.onbeforeunload = null
        this.$global.$off("get-provider")
        this.$global.$off("format-provider")
    },
}
</script>